<template>
  <div class="register">
    <div class="content">
      <div class="info">
        <div class="info_left">
          <div class="operating">
            <p class="top-titles">{{ $t("register") }}</p>
            <p v-if="this.recData" class="top-rec-text">{{ $t("rectext1") }}{{this.recName}}{{ $t("rectext2") }}</p>
            <p v-if="registerErrorMessage || this.errors.server" class="server-error-msg">
              <b>{{ this.errors.server }}</b>
            </p>

            <!-- <div class="input_box input_box_top">
              <span>{{ $t("firstName") }}</span>
              <el-input
                v-model="formRegister.FirstName"
                :placeholder="$t('firstName')"
              ></el-input>
            </div>
            <div class="input_box input_box_top">
              <span>{{ $t("lastName") }}</span>
              <el-input
                v-model="formRegister.LastName"
                :placeholder="$t('lastName')"
              ></el-input>
            </div> -->
            <div class="input_box input_box_top">
              <span style="margin-left: 30px">{{ $t("email") }}</span>
              <el-input
                :class="[this.errors.email ? 'el-input-error' : 'el-input']"
                v-model="formRegister.email"
                :placeholder="[this.errors.email ? this.errors.email : $t('enter_email_address')]"
              ></el-input>
              <span class="input_error_msg">{{ this.errors.email }}</span>
            </div>

            <div class="input_box input_box_top">
              <span style="margin-left: 30px">{{ $t("phoneOptional") }}</span>
              <el-input
                :class="[this.errors.phone ? 'el-input-error' : 'el-input']"
                v-model="formRegister.phone"
                :placeholder="[this.errors.phone ? this.errors.phone : $t('enter_phone')]"
              ></el-input>
              <span class="input_error_msg">{{ this.errors.phone }}</span>
            </div>

            <div class="input_box input_box_top">
              <span style="margin-left: 30px">{{ $t("password") }}</span>
              <el-input
                :class="[this.errors.password ? 'el-input-error' : 'el-input']"
                v-model="formRegister.password"
                type="password"
                :placeholder="[this.errors.password ? this.errors.password : $t('enter_password')]"
              ></el-input>
              <span class="input_error_msg">{{ this.errors.password }}</span>
            </div>
            <div class="input_box">
              <span style="margin-left: 30px">{{ $t("reenter_password") }}</span>
              <el-input
                :class="[this.errors.password ? 'el-input-error' : 'el-input']"
                v-model="reenterPassword"
                type="password"
                :placeholder="$t('reenter_password')"
              ></el-input>
            </div>
            <button @click="register(formRegister)" class="create_btn">
              {{ $t("createAnAccount") }}
            </button>
          </div>
          <div class="or-line">
            <span>{{ $t("or") }}</span>
          </div>
          <div class="login-types">
            <img
              :class="{'display-none': !isApp}"
              @click="signUpWithMedia('wechat')"
              src="../assets/img/login_type_wechat.png"
              alt=""
            />
             <img
              @click="signUpWithMedia('google')"
              src="../assets/img/login_type_google.png"
              alt=""
            />
            <img
              @click="signUpWithMedia('facebook')"
              src="../assets/img/login_type_facebook.png"
              alt=""
            />
            <!-- <img
              @click="signUpWithMedia('phone')"
              src="../assets/img/login_type_phone2.png"
              alt=""
            /> -->
          </div>
          <div class="already-have" @click="goToLogin()">
            <p>
              {{ $t("alreadyHaveAccount") }}&nbsp;<span>{{ $t("logIn") }}</span>
            </p>
          </div>
        </div>

        <!-- <div class="info_right">
          <div class="operating"></div>
        </div> -->
      </div>
    </div>

    <!-- <div class="login-img">
      <img src="../assets/img/signup_pic1.png" alt="" />
    </div> -->
     <div class="close-modal">
        <img
            @click="toggleRegisterModalVisibility(false)"
            src="../assets/img/closemodal.png"
            alt=""
        />
    </div>
  </div>
</template>

<script>
import { mapActions, mapState, mapMutations } from "vuex";
import Vue from 'vue';
import VueCryptojs from 'vue-cryptojs'
import {uni} from "../mixin";
Vue.use(VueCryptojs)
export default {
  name: "register",
  mixins: [uni],
  data() {
    return {
      errors: {
        email: "",
        password: "",
        server: "",
        phone: "",
      },
      labelPosition: "top",
      formRegister: {
        FirstName: "guest",
        LastName: "guest",
        email: "",
        phone: "",
        password: "",
        username: "",
        recommender: "",
      },
      reenterPassword: "",

      recData: null,
      recID: null,
      recName: null,
    };
  },
  mounted() {
    if (this.$router.currentRoute.params.idata) {
      // this.recData = this.$router.currentRoute.params.idata;
      this.recData = this.$router.currentRoute.params.idata.replace(/p1L2u3S/g, '+' ).replace(/s1L2a3S4h/g, '/').replace(/e1Q2u3A4l/g, '=');
      this.recData = this.CryptoJS.AES.decrypt(this.recData, "x").toString(this.CryptoJS.enc.Utf8);
      console.log("recData", this.recData);
      this.recID = this.recData.split('&&')[0];
      this.recName = this.recData.split('&&')[1];
    }
    // else {
    //   this.recData = null;
    //   this.recID = null;
    //   this.recName = null;
    // }
  },
  methods: {
    ...mapActions("auth", [
      "registerRequest",
      "checkUsername",
      "checkEmail",
      "LoginRequest",
    ]),
    ...mapMutations('navbar', ['toggleLoginModalVisibility', 'toggleRegisterModalVisibility', 'toggleGuestCheckoutVisiblity']),
    validEmail: function (email) {
      var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      return re.test(email);
    },
    validPhoneNumber: function (phone) {
      // const phoneNumberRegEx = /^[(]?[0-9]{3}[)]?[-\s.]?[0-9]{3}[-/\s.]?[0-9]{4}$/;
      const phoneNumberRegEx = /^\d{10}$/;
      return phoneNumberRegEx.test(phone);
    },
    checkForm(form) {
      this.errors = [];

      if (form.phone && !this.validPhoneNumber(form.phone)) {
        this.errors.phone = this.$t("phoneValidRequired");
      } else if (form.phone) {
        this.checkUsername({ username: form.username });
      }

      if (form.email && !form.phone) {
        this.checkUsername({ username: form.username });
      }

      if (!form.password || !this.reenterPassword) {
        this.errors.password = this.$t("passwordRequired");
      } else if (form.password !== this.reenterPassword) {
        this.errors.password = this.$t("passwordNotMatch");
      }
      // if (form.password.length < 8) {
      //   this.errors.push(this.$t("passwordLengthRequired"));
      // }
      // if (form.username.length < 5) {
      //   this.errors.push(this.$t("usernameLengthRequired"));
      // }
      if (!form.email) {
        this.errors.email = this.$t("emailRequired");
      } else if (!this.validEmail(form.email)) {
        this.errors.email = this.$t("emailValidRequired");
      } else {
        this.checkEmail({ email: form.email });
      }
    },
    register(form) {
      if (!this.formRegister.phone) {
        if (this.formRegister.email.length > 30) {
          form.username = this.formRegister.email.substring(0, 30);
        } else {
          form.username = this.formRegister.email;
        }
      } else {
        form.username = this.formRegister.phone;
      }
      this.checkForm(form);
      if (!this.errors.email && !this.errors.password && !this.errors.server && !this.errors.phone) {
        if (this.recData) {
          form.recommender = this.recID;
        }
        // if (this.recData && this.loggedIn === true) {
        //   this.logout2();
        // }
        this.registerRequest(form)
          .then((res) => {
            this.LoginRequest({
              username: form.username,
              password: form.password,
            });
          })
          .catch((err) => {
            this.errors = [];
            // this.errors.push(this.$t("errorCreateAccount"));
            this.errors.server = this.$t("errorCreateAccount");
          });
      }
    },
    resetCreateForm() {
      this.errors = {
        email: "",
        password: "",
        server: "",
        phone: "",
      };
      this.formRegister = {
        FirstName: "guest",
        LastName: "guest",
        email: "",
        phone: "",
        password: "",
        username: "",
        recommender: "",
      };
      this.reenterPassword = "";
    },
    goToGuestCheckout() {
      this.toggleRegisterModalVisibility(false);
      this.toggleLoginModalVisibility(false);
      this.toggleGuestCheckoutVisiblity(true);
    },
    goToLogin() {
    //   this.$router.push("/login");
        this.toggleRegisterModalVisibility(false);
        this.toggleGuestCheckoutVisiblity(false);
        this.toggleLoginModalVisibility(true);
    },
    signUpWithMedia(type) {
      switch (type) {
        case 'google':
          this.googleLogin();
          break;
        case 'wechat':
          this.wechatLogin();
          break;
        case 'facebook':
          this.facebookLogin();
          break;
      }
    },
    googleLogin() {
      if (this.isApp) {
        this.uni.postMessage({
          data: {
            action: 'googleLogin',
            params: {
              link: 'https://accounts.google.com/o/oauth2/v2/auth?response_type=code&client_id=729243143444-mgmsk07p6p6l13cgscc6rlu4sfg16abl.apps.googleusercontent.com&scope=openid%20email&redirect_uri=https%3A%2F%2Fshopafm.com%2Fgoogle-auth2&hd=gmail.com'
            }
          }
        })
        return
      }
      // window.location.href = 'https://accounts.google.com/o/oauth2/v2/auth?response_type=code&client_id=729243143444-mgmsk07p6p6l13cgscc6rlu4sfg16abl.apps.googleusercontent.com&scope=openid%20email&redirect_uri=https%3A%2F%2Fafmstage-web.truckxi.com%2Fgoogle-auth2&hd=gmail.com';
      window.location.href = 'https://accounts.google.com/o/oauth2/v2/auth?response_type=code&client_id=729243143444-mgmsk07p6p6l13cgscc6rlu4sfg16abl.apps.googleusercontent.com&scope=openid%20email&redirect_uri=https%3A%2F%2Fshopafm.com%2Fgoogle-auth2&hd=gmail.com'
    },
    wechatLogin() {
      if (this.isApp) {
        this.uni.postMessage({
          data: {
            action: 'wechatLogin'
          }
        })
        return
      }
      // window.location.href = 'https://open.weixin.qq.com/connect/qrconnect?appid=wx517d4ee68cb91670&redirect_uri=https%3A%2F%2Fafmstage-web.truckxi.com%2Fwechat-auth2&scope=snsapi_login#wechat_redirect';
      window.location.href = 'https://open.weixin.qq.com/connect/qrconnect?appid=wx517d4ee68cb91670&redirect_uri=https%3A%2F%2Fshopafm.com%2Fwechat-auth2&scope=snsapi_login#wechat_redirect';
    },
    facebookLogin() {
      if (this.isApp) {
        this.uni.postMessage({
          data: {
            action: 'facebookLogin',
            params: {
              link: 'https://www.facebook.com/v10.0/dialog/oauth?client_id=1219276968470230&scope=&response_type=code&redirect_uri=https%3A%2F%2Fshopafm.com%2Ffacebook-auth2'
            }
          }
        })
        return
      }
      // window.location.href = 'https://www.facebook.com/v10.0/dialog/oauth?client_id=1219276968470230&scope=&response_type=code&redirect_uri=https%3A%2F%2Fafmstage-web.truckxi.com%2Ffacebook-auth2';
      window.location.href = 'https://www.facebook.com/v10.0/dialog/oauth?client_id=1219276968470230&scope=&response_type=code&redirect_uri=https%3A%2F%2Fshopafm.com%2Ffacebook-auth2'
    }
  },
  computed: mapState({
    registerErrorMessage: (state) => state.auth.registerErrorMessage,
    registerModalVisibilityGlobal: state => state.navbar.registerModalVisibilityGlobal,
    loggedIn: state => state.auth.loggedIn,
  }),
  watch: {
    registerErrorMessage: function (newVal, oldVal) {
      if (newVal === "username") {
        this.errors.server = this.$t("usernameTaken");
        if (this.formRegister.phone) {
          this.errors.server = this.$t("phoneTaken");
        } else {
          this.errors.server = this.$t("emailTaken");
        }
      }
      if (newVal === "email") {
        this.errors.server = this.$t("emailTaken");
      }
      if (newVal === "fail") {
        this.errors.server = this.$t("server_error");
      }
    },
    $route(to, from) {
      this.resetCreateForm();
    },
    registerModalVisibilityGlobal: function(newVal, oldVal) {
      this.resetCreateForm();
    },
    loggedIn: function(newVal, oldVal) {
        if (newVal === true) {
            this.toggleRegisterModalVisibility(false);
        }
    },
  },
};
</script>

<style scoped lang="less">
@import "../assets/css/public.less";
@import "../assets/css/registerNew.less";
</style>



// WEBPACK FOOTER //
// src/view/registerNew.vue